import React from "react";
import "./PageHeader.scss";
import HtmlContent from "./HtmlContent";

const PageHeader = ({ title, subtitle, icon, isCenter = true }) => {
    return;
    return (
        title && <div className="page-header">
            <div className="header-container" style={{alignItems: `${isCenter ? 'center' : 'start'}`}}>
                <div className="page-title">{icon && <span style={{marginRight: "8px"}}>{icon}</span>}<HtmlContent content={title} /></div>
                {subtitle && <div className="sub-title">{subtitle}</div>}
            </div>
        </div>
    );
}

export default PageHeader;